import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "tabs" }
const _hoisted_2 = { class: "tabs-header" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "tabs-content" }

import ScrollableContainer from './Containers/ScrollableContainer.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Tabs',
  props: {
    activeTabName: null,
    tabs: null
  },
  emits: ["update:activeTabName"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:activeTabName', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  activeTabName: string;
  tabs: string[];
}





const selectTab = (tab: string) => {
  if (tab === props.activeTabName) return;
  emit('update:activeTabName', tab);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ScrollableContainer, { hideScrollbar: true }, {
        default: _withCtx(() => [
          (__props.tabs.length > 1)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(__props.tabs, (tab) => {
                return (_openBlock(), _createElementBlock("button", {
                  class: _normalizeClass(["tabs-header__button", { active: __props.activeTabName === tab }]),
                  key: tab,
                  onClick: ($event: any) => (selectTab(tab))
                }, _toDisplayString(tab), 11, _hoisted_3))
              }), 128))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_Transition, {
        name: "fade",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, __props.activeTabName)
        ]),
        _: 3
      })
    ])
  ]))
}
}

})